import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";
import getSsn from "../../common/Ssn";
import { getDobDate, getDodDate } from "../../common/DisplayDate";

class NeighborsGold extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  loadData = (props) => {
    const rows = [];
    const recCount = 0;
    if (props.reportData !== undefined) {
      const neighbors = _.get(this.props.node, "neighbors[0].neighbor");
      if (neighbors !== undefined) {
        _.forEach(neighbors, (neighbor, neighborIndex) => {
          const neighborRows = [];
          const name = `${_.get(
            neighbor,
            "names[0].name[0].firstName[0]._",
            ""
          )} ${_.get(
            neighbor,
            "names[0].name[0].middleInitial[0]._",
            ""
          )} ${_.get(neighbor, "names[0].name[0].lastName[0]._", "")}`;
          neighborRows.push(
            <Table.Row
              key={`row_neigh_name_${neighborIndex}`}
            >
              <Table.Cell width={2}> Name: </Table.Cell>
              <Table.Cell width={6}>
                {name}
              </Table.Cell>
              <Table.Cell width={2}> SSN: </Table.Cell>
              <Table.Cell width={6}>
                {getSsn(_.get(neighbor, "SSNs[0].SSNRecord[0].SSN[0]._"), this.props)}
              </Table.Cell>
            </Table.Row>
          );
          neighborRows.push(
            <Table.Row
              key={`row_neigh_dob_${neighborIndex}`}
            >
              <Table.Cell width={2}> DOB: </Table.Cell>
              <Table.Cell width={6}>
                {getDobDate(_.get(neighbor, "DOBs[0].DOB[0]"), this.props)}
              </Table.Cell>
              <Table.Cell width={2}> DOD: </Table.Cell>
              <Table.Cell width={6}>
                {getDodDate(_.get(neighbor, "DODs[0].DOD[0]"), this.props)}
              </Table.Cell>
            </Table.Row>
          );
          neighborRows.push(
            <Table.Row
              key={`row_neigh_address_${neighborIndex}`}
            >
              <Table.Cell width={2}> Address: </Table.Cell>
              <Table.Cell width={6}>
                <Address addressNode={_.get(neighbor, "addresses[0].address[0]")} {...this.props} />
              </Table.Cell>
              <Table.Cell width={2} />
              <Table.Cell width={6} />
            </Table.Row>
          );
          rows.push(<SimpleAccordionContent
            key={`ind_neigh_${neighborIndex}`}
            {...this.props}
            name={name}
            rows={neighborRows}
          />);
        });
      } else {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Neighbors"}
        rows={this.state.rows}
      />
    );
  }
}

export default NeighborsGold;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/NeighborsGold.js